import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import type {RouteQueryKey} from '@github-ui/react-core/query-key'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import type {RefObject} from 'react'

import {MilestoneDate} from './MilestoneDate'
import {MilestoneIssueCount} from './MilestoneIssueCount'
import {MilestoneRowMetadata} from './MilestoneRowMetadata'
import {MilestoneRowTitle} from './MilestoneRowTitle'
import type {MilestoneNode} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

// RELAY-CLEANUP(RepositoryMilestoneIndexPageContentInternal): widens nullable fields so the still-Relay parent
// data is assignable. Remove when RepositoryMilestoneIndexPageContentInternal leaves Relay.
export type MilestoneRowFragment = RelayCompat<
  Pick<
    MilestoneNode,
    | 'closed'
    | 'closedIssueCount'
    | 'description'
    | 'dueOn'
    | 'id'
    | 'openIssueCount'
    | 'progressPercentage'
    | 'repository'
    | 'state'
    | 'title'
    | 'url'
  >
>

type MilestoneRowProps = {
  milestone: MilestoneRowFragment
  repositoryNameWithOwner: string
  queryKey?: RouteQueryKey
  listFocusRef?: RefObject<HTMLDivElement | null>
}

export function MilestoneRow({milestone: data, repositoryNameWithOwner, queryKey, listFocusRef}: MilestoneRowProps) {
  const title = <MilestoneRowTitle milestone={data} />
  const metadata = (
    <MilestoneRowMetadata
      milestone={data}
      repositoryNameWithOwner={repositoryNameWithOwner}
      queryKey={queryKey}
      listFocusRef={listFocusRef}
    />
  )

  return (
    <ListItem
      key={data.id}
      title={title}
      role="listitem"
      metadata={metadata}
      className={styles.milestoneRow}
      metadataContainerClassName={styles.listMetadataContainer}
    >
      <ListItemMainContent>
        <ListItemDescription className={styles.listItemContent}>
          {data.description && <p className={styles.listDescription}>{data.description}</p>}
          <div className={styles.listDateContainer}>
            <MilestoneDate milestone={data} />
            <MilestoneIssueCount milestone={data} />
          </div>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}
